import { Button, ButtonSize, ButtonVariant, Modal } from "shared/components";
import { InfoCircle } from "untitledui-js-base";

export const DeleteWebhookModal = ({
  open,
  setOpen,
  isPending,
  onSuccess
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSuccess: () => void;
  isPending: boolean;
}) => {
  return (
    <Modal
      opened={open}
      onClose={() => setOpen(false)}
      panelClassName="p-6 max-w-[366px] w-full"
    >
      <div className="flex items-center justify-center rounded-full bg-danger-50 p-4 mb-6 mx-auto w-16">
        <InfoCircle size="32px" className="stroke-danger-500" />
      </div>

      <h1 className="text-xl font-bold text-content-1000 mb-2 text-center">
        Delete this webhook{" "}
      </h1>
      <p className="text-sm text-content-400 mb-6 text-center font-medium">
        You&apos;re about to delete your webhook. If you have configured a
        service with it, that service will no longer receive data
      </p>
      <div className="flex gap-2 w-full">
        <div className="w-full">
          <Button
            size={ButtonSize.BASE}
            variant={ButtonVariant.BASE}
            className="w-full"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </div>
        <div className="w-full">
          <Button
            size={ButtonSize.BASE}
            variant={ButtonVariant.PRIMARY}
            className="w-full"
            loading={isPending}
            disabled={isPending}
            onClick={() => {
              !isPending && onSuccess();
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
